import {Box} from "@mui/material";
import ProfileTextfield from "./modues/ProfileTextfield";
import {useState} from "react";
import {updateData} from "../../lib/dashboard/actions";
import {profilePasswordSchema} from "../../validation";
import {toast} from "react-toastify";
import ProfileFormButtons from "./modues/ProfileFormButtons";

const ProfileSecurityInfo = ({editMode, setEditMode}) => {

    const [passwords, setPasswords] = useState({
        old_password: "",
        new_password: "",
        confirm_new_password: ""
    })
    const [isSaving, setIsSaving] = useState(false);
    const [errors, setErrors] = useState({});

    // handler for editing
    const handleChange = (field) => (event) => {
        setPasswords((prevValues) => ({
            ...prevValues,
            [field]: event.target.value,
        }));
    };

    //save new password and validation
    const handleSavePassword = async () => {
        const result = profilePasswordSchema.safeParse({
            old_password: passwords.old_password,
            new_password: passwords.new_password,
            confirm_password: passwords.confirm_new_password,
        });
        if (!result.success) {
            const fieldErrors = {};
            result.error.errors.forEach((err) => {
                const field = err.path[0] === "confirm_password" ? "confirm_new_password" : err.path[0];
                fieldErrors[field] = err.message;
            });
            setErrors(fieldErrors);
            return;
        }

        setErrors({});
        setIsSaving(true);
        const {data, msg} = await updateData(
            {
                old_password: passwords.old_password,
                new_password: passwords.new_password,
            },
            "/account/password",
            "PUT"
        );
        if (msg === "error") {
            toast.error(data.old_password)
        }
        setEditMode(false);
        setIsSaving(false);
    };

    //cancel and make back textfields value back to normal
    const handleCancel = () => {
        setPasswords({
            old_password: "",
            new_password: "",
            confirm_new_password: "",
        });
        setEditMode(false);
        setErrors({});
    };

    return (
        <>
            <ProfileTextfield
                label="گذرواژه فعلی"
                type="password"
                value={passwords.old_password}
                onChange={handleChange("old_password")}
                disabled={!editMode}
                error={!!errors.old_password}
                helperText={errors.old_password}
            />

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: {xs: "column", md: "row"},
                    gap: "20px",
                }}
            >
                <ProfileTextfield
                    label="گذرواژه جدید"
                    type="password"
                    value={passwords.new_password}
                    onChange={handleChange("new_password")}
                    disabled={!editMode}
                    error={!!errors.new_password}
                    helperText={errors.new_password}
                />
                <ProfileTextfield
                    label="تایید گذرواژه"
                    type="password"
                    value={passwords.confirm_new_password}
                    onChange={handleChange("confirm_new_password")}
                    disabled={!editMode}
                    error={!!errors.confirm_new_password}
                    helperText={errors.confirm_new_password}
                />
            </Box>
            {editMode && (
                <ProfileFormButtons
                    submitForm={handleSavePassword}
                    cancelForm={handleCancel}
                    loading={isSaving}
                />
            )}
        </>
    );
};

export default ProfileSecurityInfo;